export default __webpack_public_path__ + "static/Refrigeration_2-5e701b933c8040cfa280536edfd31d93.jpg";